export const COMMON_ROOM_INFO_MESSAGE =
  'A channel where everyone can connect with others, ask questions, share ideas, and join discussions.';
